<template>
    <!--弹窗-->
    <el-dialog
        :visible="true"
        width="500px"
        title="绑定广告组合名称"
        :before-close="handleClose"
    >
        <el-form ref="formData" label-width="120px" size="mini">
            <el-form-item label="广告组合名称：">
                <el-select
                    v-model="ad_portfolio_name_id"
                    ref="carrerSelect"
                    style="width: 150px; margin-top: 5px"
                    size="mini"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="item in adList"
                        :key="item.id"
                        :label="item.ad_portfolio_name"
                        :value="item.id"
                    >
                        <div class="keywords_arr_div">
                            <span
                                style="font-weight: 700; font-size: 14px; margin-left: 10px"
                                >{{ item.ad_portfolio_name }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-row style="margin-top: 17px">
            <el-button
                style="float: right; margin-left: 6px"
                size="mini"
                type="danger"
                plain
                @click="handleClose(false)"
                >取 消</el-button
            >
            <el-button
                style="float: right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            loading: false,
            formData: {},
            adList: [],
            ad_portfolio_name_id: 0
        };
    },
    props: {
        data: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    mounted() {
        this.ad_portfolio_name_id = this.data.ad_portfolio_name_id || 0;
        console.log('========', this.data)
        this.getList();
    },
    methods: {
        // 保存信息
        submitForm() {
            this.loading = true
            api.asin_set_portfolio_name({
                id: this.data.id || 0,
                state: this.data.state,
                ad_portfolio_id: this.ad_portfolio_name_id || 0
            }).then((res) => {
                if (res.success) {
                    this.$message.success("修改成功");
                    this.$emit("close");
                    this.$emit("onUpdate");
                } else {
                    this.$message.error(res.message)
                }
            }).finally(()=>{
                this.loading = false
            });
        },
        getList() {
            api.asin_get_portfolio_list({
                state: this.data.state,
                id: this.data.id || 0,
            }).then(res => {
                console.log(res);
                this.adList = [{ ad_portfolio_name: "置空", id: 0 }];
                this.adList = [
                    { ad_portfolio_name: "置空", id: 0 },
                    ...res.data
                ];
            });
        },
        // 关闭弹窗
        handleClose() {
            this.$emit("close");
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
</style>
